module.exports = __webpack_public_path__ + "img/top-list-left2.faddad2f.png";